import ScrollWrapper from '../ScrollWrapper'
import FormProvider from './form/Provider'
import { Form, OnFormSubmit } from './form/types'
import Content from './parts/Content'
import DismissOverlayProvider from '@/features/ui/components/Dropdown/contexts/DismissOverlay'
import React, { FC } from 'react'

interface NotificationConfigurationProps {
    initialFormValues: Form
    onFormSubmit: OnFormSubmit
}

const NotificationConfiguration: FC<NotificationConfigurationProps> = ({
    initialFormValues,
    onFormSubmit,
}) => {
    return (
        <DismissOverlayProvider>
            <ScrollWrapper>
                <FormProvider initialFormValues={initialFormValues}>
                    <Content onFormSubmit={onFormSubmit} />
                </FormProvider>
            </ScrollWrapper>
        </DismissOverlayProvider>
    )
}

export default NotificationConfiguration
